<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
        <div class="pl-8 pr-8 col-md-12 ml-sm-auto col-lg-12">
            <v-row>
                <v-col cols="7">
                    <Package />
                </v-col>
                <v-col>
                    <PiePackage />
                </v-col>
            </v-row>
        </div>
    </v-main>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import adminLeftMenu from '../Sidebar.vue' // เมนู
import Package from '../Chart/Package.vue'
import PiePackage from '../Chart/PiePackage.vue'

export default {
  name: 'home',
  components: {
    'left-menu-admin': adminLeftMenu,
    'DateRanlengAgegePicker': DateRangePicker,
    Package,
    PiePackage
  },
  data () {
    let startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 2)
      .toISOString()
      .substr(0, 10)
    let endDate = new Date(Date.now() - new Date().getTimezoneOffset() * 30000)
      .toISOString()
      .substr(0, 10)
    return {
      status: true,
      tab: null,
      chartData: null,
      firstDay: 0,
      format: 'yyyy-mm-dd',
      dateRange: {
        startDate,
        endDate
      },
      paramStatus: true,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/Core/Home'
        }
      ],
      session: this.$session.getAll()
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.start_month = new Date(this.dateRange.startDate).toLocaleString(
      'th-TH',
      {
        month: 'long'
      }
    )
    this.end_month = new Date(this.dateRange.endDate).toLocaleString('th-TH', {
      month: 'long'
    })
    if (this.$route.query.callBack) {
      this.$router.push(
        this.$route.query.callBack +
          '&rewardId=' +
          this.$route.query.rewardId +
          '&rewardCode=' +
          this.$route.query.rewardCode +
          '&lineUserId=' +
          this.$route.query.lineUserId
      )
    }
  },
  methods: {
    routePage (path) {
      this.$router.push(path)
    }
    // async manage () {
    //   this.start_month = new Date(this.dateRange.startDate).toLocaleString(
    //     'th-TH',
    //     {
    //       month: 'long'
    //     }
    //   )
    //   this.end_month = new Date(this.dateRange.endDate).toLocaleString(
    //     'th-TH',
    //     {
    //       month: 'long'
    //     }
    //   )
    //   this.paramStatus = false
    //   this.$refs.modal1.getData(this.dateRange, this.paramStatus)
    //   this.$refs.modal2.getData(this.dateRange, this.paramStatus)
    //   this.$refs.modal3.getData(this.dateRange, this.paramStatus)
    //   this.$refs.modal4.getData(this.dateRange, this.paramStatus)
    //   this.$refs.modal5.branchNameData(this.dateRange)
    //   this.$refs.modal6.getData(this.dateRange)
    //   this.$refs.modal7.getData(this.dateRange)
    //   this.$refs.modal8.branchNameData(this.dateRange)
    //   this.$refs.modal9.serviceData(this.dateRange)
    //   await this.$refs.modal10.axisX(this.dateRange)
    //   this.$refs.modal10.getChart()
    //   this.$refs.modal11.init(this.dateRange)
    //   await this.$refs.modal11.axisX(this.dateRange)
    //   this.$refs.modal11.getChart()
    //   this.$refs.modal12.getData(this.dateRange, this.paramStatus)
    //   this.$refs.modal13.getData(this.dateRange, this.paramStatus)
    //   this.$refs.modal14.Stock(this.dateRange, this.paramStatus)
    // }
  }
}
</script>
<style scope>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/Core/PackageMain.vue